<template>
    <div id="left-board">
        <div id="selection-box">
            <div id="selection-color" :style="{ 'background-color': convertAlpha(currentColor) }"></div>
        </div>
        <div id="color-grid-container">
            <div class="color-item" :style="{ 'background-color': convertAlpha(color) }"
                v-for="(color, index) in colors" :key="color" :id="'color-' + (colors.length - index - 1)"
                @click="setColor(color)"></div>
        </div>
    </div>
    <div id="right-board">
        <div id="draw-style-grid-container">
            <div class="draw-style-item" v-for="(drawStyle, index) in drawStyles" :key=index :id="'drawStyle-' + index"
                @click="setDrawTool(drawStyle)">
                <img class="item-image" :src="getSrc(drawStyle, drawStyle == currentDrawStyle)" />
                <span class="item-text">{{ language[drawStyles[index]] }}</span>
            </div>
        </div>
        <div id="draw-width-box">
            <span id="draw-width-title">寬度</span>
            <div class="draw-width-grid-container">
                <div class="draw-width-item" v-for="(drawWidth, index) in drawWidths" :key="index"
                    :id="'drawStyle-' + index" @click="setWidth(drawWidth)">
                    <img class="item-image" :src="getSrc('width_' + drawWidth, drawWidth == currentWidth)" />
                    <span class="item-text">{{ drawWidths.length - index }}</span>
                </div>
            </div>
        </div>
        <div id="hollow-box">
            <div class="hollow-item" @click="setHollow(false)">
                <img class="item-image" :src="getSrc('solid', !currentHollow)" />
                <span class="item-text">實心</span>
            </div>
            <div class="hollow-item" @click="setHollow(true)">
                <img class="item-image" :src="getSrc('hollow', currentHollow)" />
                <span class="item-text">空心</span>
            </div>
        </div>
    </div>
</template>

<script>
import DEFINE from '@/js/painter/define';

export default {
    name: "PaintSetting",
    data: function () {
        return {
            operate: DEFINE.OPERATE.PEN,
            // 翻譯
            language: {
                free: "自由",
                straight_line: "直線",
                horizon_line: "水平線",
                vertical_line: "垂直線",
                shape_full_up: "圖形填色",
                line_full_up: "線框填色",
                hollow_out: "挖空",
                dotted_line: "虛線",
                arrow: "射線",
                circle: "圓形",
                retangle: "矩形",
                triangle: "三角形",
                polygon: "多邊形",
                star: "星形",
            },
            // 畫筆顏色
            penColors: [
                DEFINE.COLOR.PEN.RED, DEFINE.COLOR.PEN.WINE_RED, DEFINE.COLOR.PEN.YELLOW, DEFINE.COLOR.PEN.ORANGE,
                DEFINE.COLOR.PEN.LIGHT_GREEN, DEFINE.COLOR.PEN.DEEP_GREEN, DEFINE.COLOR.PEN.BROWN, DEFINE.COLOR.PEN.CADET_BLUE,
                DEFINE.COLOR.PEN.PINK, DEFINE.COLOR.PEN.PURPLE, DEFINE.COLOR.PEN.BLUE, DEFINE.COLOR.PEN.AUQA,
                DEFINE.COLOR.PEN.BLACK, DEFINE.COLOR.PEN.DARK_GRAY, DEFINE.COLOR.PEN.GRAY, DEFINE.COLOR.PEN.WHITE
            ],
            hightLighterColors: [
                DEFINE.COLOR.HIGHLIGHTER.RED, DEFINE.COLOR.HIGHLIGHTER.WINE_RED,
                DEFINE.COLOR.HIGHLIGHTER.YELLOW, DEFINE.COLOR.HIGHLIGHTER.ORANGE,
                DEFINE.COLOR.HIGHLIGHTER.LIGHT_GREEN, DEFINE.COLOR.HIGHLIGHTER.DEEP_GREEN,
                DEFINE.COLOR.HIGHLIGHTER.BROWN, DEFINE.COLOR.HIGHLIGHTER.CADET_BLUE,
                DEFINE.COLOR.HIGHLIGHTER.PINK, DEFINE.COLOR.HIGHLIGHTER.PURPLE,
                DEFINE.COLOR.HIGHLIGHTER.BLUE, DEFINE.COLOR.HIGHLIGHTER.AUQA,
                DEFINE.COLOR.HIGHLIGHTER.BLACK, DEFINE.COLOR.HIGHLIGHTER.DARK_GRAY,
                DEFINE.COLOR.HIGHLIGHTER.GRAY, DEFINE.COLOR.HIGHLIGHTER.WHITE
            ],
            colorName: {
                "rgba(255, 0 ,0, 1)": "紅",
                "rgba(153, 0 ,0, 1)": "暗紅",
                "rgba(255, 255 ,0, 1)": "黃",
                "rgba(255, 102 ,0, 1)": "橙",
                "rgba(0, 255 ,0, 1)": "綠",
                "rgba(0, 153 ,0, 1)": "深綠",
                "rgba(153, 102 ,0, 1)": "棕",
                "rgba(0, 153 ,153, 1)": "青藍",
                "rgba(255, 0 ,255, 1)": "洋紅",
                "rgba(102, 0 ,255, 1)": "深紫",
                "rgba(0, 0 ,255, 1)": "藍",
                "rgba(0, 255 ,255, 1)": "青",
                "rgba(0, 0 ,0, 1)": "黑",
                "rgba(84, 84 ,84, 1)": "深灰",
                "rgba(168, 168 ,168, 1)": "淺灰",
                "rgba(255, 255 ,255, 1)": "白"
            },
            drawingPenLightColorName: {
                "rgba(255, 0 ,0, 0.5)": "紅",
                "rgba(153, 0 ,0, 0.5)": "暗紅",
                "rgba(255, 255 ,0, 0.5)": "黃",
                "rgba(255, 102 ,0, 0.5)": "橙",
                "rgba(0, 255 ,0, 0.5)": "綠",
                "rgba(0, 153 ,0, 0.5)": "深綠",
                "rgba(153, 102 ,0, 0.5)": "棕",
                "rgba(0, 153 ,153, 0.5)": "青藍",
                "rgba(255, 0 ,255, 0.5)": "洋紅",
                "rgba(102, 0 ,255, 0.5)": "深紫",
                "rgba(0, 0 ,255, 0.5)": "藍",
                "rgba(0, 255 ,255, 0.5)": "青",
                "rgba(0, 0 ,0, 0.5)": "黑",
                "rgba(84, 84 ,84, 0.5)": "深灰",
                "rgba(168, 168 ,168, 0.5)": "淺灰",
                "rgba(255, 255 ,255, 0.5)": "白"
            },
            colors: [],
            // 畫筆類型
            drawStyles: [
                DEFINE.DRAW_STYLE.FREE, DEFINE.DRAW_STYLE.STRAIGHT_LINE,
                DEFINE.DRAW_STYLE.HORIZON_LINE, DEFINE.DRAW_STYLE.VERTICAL_LINE,
                DEFINE.DRAW_STYLE.SHAPE_FULL_UP, DEFINE.DRAW_STYLE.LINE_FULL_UP,
                DEFINE.DRAW_STYLE.HOLLOW_OUT, DEFINE.DRAW_STYLE.DOTTED_LINE,
                DEFINE.DRAW_STYLE.ARROW, DEFINE.DRAW_STYLE.CIRCLE,
                DEFINE.DRAW_STYLE.RETANGLE, DEFINE.DRAW_STYLE.TRIANGLE,
                DEFINE.DRAW_STYLE.POLYGON, DEFINE.DRAW_STYLE.STAR
            ],
            brushName: {
                "free": "自由",
                "straight_line": "直線",
                "horizon_line": "水平線",
                "vertical_line": "垂直線",
                "shape_full_up": "圖形填色",
                "line_full_up": "線框填色",
                "hollow_out": "挖空",
                "dotted_line": "虛線",
                "arrow": "箭頭",
                "circle": "圓形",
                "retangle": "矩形",
                "triangle": "三角形",
                "polygon": "多邊形",
                "star": "星型",
            },
            // 畫筆寬度
            drawWidths: [35, 30, 20, 15, 10, 5, 3, 2],
            // 當前畫布狀態
            currentColor: "",
            currentDrawStyle: "",
            currentWidth: 0,
            currentHollow: false,
        };
    },
    methods: {
        setColor(color) {
            this.currentColor = color;
        },
        setDrawTool(drawStyle) {
            this.currentDrawStyle = drawStyle;
        },
        setWidth(width) {
            this.currentWidth = width;
        },
        setHollow(isHollow) {
            this.currentHollow = isHollow;
        },
        getSrc(fileName, isSelect) {
            return require('@/assets/art/paint_setting/' + fileName + ((isSelect) ? "_s2" : "") + '.svg');
        },
        convertAlpha(rgb) {
            return rgb.replace('0.5', '1');
        },
        updateColor() {
            if (this.operate == DEFINE.OPERATE.PEN) {
                this.colors = this.penColors;
            } else if (this.operate == DEFINE.OPERATE.HIGHLIGHTER) {
                this.colors = this.hightLighterColors;
            }
        },
        getData() {
            let type = this.operate == DEFINE.OPERATE.PEN ? "drawingPen-tool" : "drawingPenLight-tool";
            let color = this.operate == DEFINE.OPERATE.PEN ? this.colorName[this.currentColor] : this.drawingPenLightColorName[this.currentColor];
            let solid = this.currentHollow ? '空心' : '實心';

            return {
                "type": type,
                "operate": this.operate,
                "color": color,
                "colorSetting": this.currentColor,
                "brushType": this.brushName[this.currentDrawStyle],
                "brushSetting": this.currentDrawStyle,
                "solid": solid,
                "soildSetting": this.currentHollow,
                "brushSize": this.currentWidth
            };
        }
    }
};
</script>

<style src="@/css/cursor/PaintSetting.css" scoped></style>